import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=ec6a2266&scoped=true&"
import script from "./Update.vue?vue&type=script&lang=ts&"
export * from "./Update.vue?vue&type=script&lang=ts&"
import style0 from "./Update.vue?vue&type=style&index=0&id=ec6a2266&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6a2266",
  null
  
)

export default component.exports